import {
  AlertTriangle,
  Boxes,
  Brush,
  Building,
  Building2,
  ClipboardCheck,
  ClipboardList,
  CloudSun,
  Cpu,
  Database,
  FileText,
  Gauge,
  Layers,
  LayoutDashboard,
  LayoutTemplate,
  Mail,
  Map as MapIcon,
  Palette,
  ScrollText,
  Settings,
  SlidersHorizontal,
  Sparkles,
  UserCheck,
  Users,
  Wheat,
  Zap,
  Circle,
} from "lucide-react";

/** Nome do ícone (definido no catálogo do backend) -> componente lucide. */
const ICONS = {
  AlertTriangle,
  Boxes,
  Brush,
  Building,
  Building2,
  ClipboardCheck,
  ClipboardList,
  CloudSun,
  Cpu,
  Database,
  FileText,
  Gauge,
  Layers,
  LayoutDashboard,
  LayoutTemplate,
  Mail,
  Map: MapIcon,
  Palette,
  ScrollText,
  Settings,
  SlidersHorizontal,
  Sparkles,
  UserCheck,
  Users,
  Wheat,
  Zap,
};

export function catalogIcon(name) {
  return ICONS[name] || Circle;
}
